export const BASE_URL = process.env.REACT_APP_PUBLIC_API_URL || 'http://localhost:3001';
// export const BASE_URL = 'http://54.75.82.149:3000';
